import { useContext } from "react";
import { OrganisationContext } from "../context/OrganisationContext";
import { InvoiceExtractedResponseModel } from "../models/InvoiceExtractionModels";
import { environment } from "../config/environment";
import useSWR from "swr";
import { useSWRFetcher } from "./useSWRFetcher";

export const useInvoiceExtractedData = (jobId: string) => {
  const fetcher = useSWRFetcher();
  const { invoiceExtractionJobs } = useContext(OrganisationContext);
  const job = invoiceExtractionJobs?.find((job) => job.id === jobId);
  const { data, isLoading, error } = useSWR<InvoiceExtractedResponseModel>(
    job && job.data.invoiceData ? `${environment.apiUrl}/api/payable-invoices/extraction/${jobId}` : null,
    fetcher
  );

  return {
    invoiceExtractedData: data,
    isExtractedDataLoading: isLoading, // isLoading || job?.state !== "Extracted",
    isExtractedDataError: !!error,
  };
};
